import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  BidvTransferDestWhitelistService,
  BidvTransferDestWhitelistItemEntity,
  UpdateBidvTransferDestWhitelistDto,
} from 'services/openapi';

import { BidvBankTransferServiceKeys } from '../queries/constants';

type UpdateVariables = UpdateBidvTransferDestWhitelistDto & { id: string };

export const useUpdateBidvTransferDestWhitelistMutation = () => {
  const queryClient = useQueryClient();

  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<BidvTransferDestWhitelistItemEntity, Error, UpdateVariables>({
      mutationFn: ({ id, ...rest }: UpdateVariables) =>
        BidvTransferDestWhitelistService.bidvTransferDestWhitelistControllerUpdate(
          id,
          rest,
        ),
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [BidvBankTransferServiceKeys.GET_TRANSFER_DEST_WHITELIST],
        });
      },
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
